// Libraries
import { Stack } from "@mui/material";
import clsx from "clsx";

// Components
import Button from "@/Layouts/components/Buttons/Button";

type TActionButtonProps = {
	text: string;
	disabled: boolean;
	onClick: () => void;
};

export default function ActionButton(props: Readonly<TActionButtonProps>) {
	const { text, disabled, onClick } = props;

	return (
		<Stack justifyContent="flex-start" className="!ml-6 !mt-9">
			<Button
				variant="contained"
				text={text}
				classes={clsx({
					"h-[30px] !rounded-[6px] btn-regular-text": true,
					"!bg-primary hover:!shadow-primary-shadow-50 ": !disabled,
					"!bg-disabled !text-white": disabled,
				})}
				onClick={onClick}
				disabled={disabled}
			/>
		</Stack>
	);
}
